
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import axios from 'axios'

@Component
export default class VerificationModal extends Vue {
  @Prop({ type: String, required: true }) email!: string
  @Prop({ type: String, required: true }) phone!: string
  @Prop({ type: String, default: 'email' }) defaultMethod!: 'email' | 'sms'

  method: 'email' | 'sms' = 'email'

  verificationCode = ''

  showToast = false
  toastMessage = ''
  toastType: 'success' | 'error' | 'warning' | '' = ''
  toastTimer: number | null = null
  timerCount: number = 30

  created() {
    this.method = this.defaultMethod
    this.timerCount = 30;
    this.countDownTimer();
    this.focusVerificationInput();
  }

  focusVerificationInput() {
    (this.$refs.verificationCodeInput as HTMLElement).focus();
  }

  countDownTimer() {
    if (this.timerCount > 0){
      setTimeout(() => {
        this.timerCount--;
        this.countDownTimer();
      }, 1000);
    }
  }

  get currentMethodDisplay() {
    return this.method === 'email'
      ? `email: ${this.email}`
      : `phone: ${this.phone}`
  }

  get timeOver() {
    console.log(`Current timer is ${this.timerCount}`);
    return this.timerCount <= 0;
  }

  displayToast(message: string, type: 'success' | 'error' | 'warning') {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer)
      this.toastTimer = null
    }

    this.toastMessage = message
    this.toastType = type
    this.showToast = true

    this.toastTimer = window.setTimeout(() => {
      this.closeToast()
    }, 30000)
  }

  closeToast() {
    this.showToast = false
    this.toastMessage = ''
    this.toastType = ''
    if (this.toastTimer) {
      clearTimeout(this.toastTimer)
      this.toastTimer = null
    }
  }

  async resendCode() {
    try {
      if (this.method === 'email') {
        await axios.post(`${process.env.VUE_APP_API}/verification/send-code`, {
          method: 'email',
          email: this.email,
          phone: null
        })
      } else {
        await axios.post(`${process.env.VUE_APP_API}/verification/send-code`, {
          method: 'sms',
          email: null,
          phone: this.phone
        })
      }
      this.displayToast('Code resent successfully!', 'success')
      this.timerCount = 30;
      this.countDownTimer();
    } catch {
      this.displayToast('Error resending code.', 'error')
    }
  }

  async verifyCode() {
    try {
      const payload =
        this.method === 'email'
          ? { method: 'email', email: this.email, phone: null, code: this.verificationCode }
          : { method: 'sms', email: null, phone: this.phone, code: this.verificationCode }

      const response = await axios.post(`${process.env.VUE_APP_API}/verification/verify-code`, payload)
      if (response.data.success) {
        this.displayToast('Verification successful!', 'success')
        this.$emit('verified')
      } else {
        this.displayToast(
          `Verification failed: ${response.data.message || 'Invalid code.'}`,
          'warning'
        )
      }
    } catch {
      this.displayToast('Error verifying code.', 'error')
    }
  }

  onGoBack() {
    this.$emit('go-back')
  }
}
